






















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { checkSelfRole } from "@/common/role_utils";
import { AllSchedulePPD, DepartmentSchedulePPD, SchedulePPD } from "@/api";

interface TitlePPD {
  title_id: number;
  title_name: string;
  target_ppd?: number | null;
  actual_work_hour?: number | null;
}

interface DepartmentPPD {
  department_id: number;
  department_name: string;
  target_ppd?: number | null;
  actual_work_hour?: number | null;
  titles: TitlePPD[];
}

@Component
export default class UpdatePPDModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: "" }) date!: string;

  internalValue = this.value;
  loading = false;
  saving = false;
  activeValue = -1;

  get formattedDate(): string {
    if (!this.date) return "";
    return moment(this.date).format("MMMM D, YYYY");
  }

  @Watch("value")
  onValueChange(val: boolean) {
    this.internalValue = val;
    if (val) {
      this.fetchPPDData();
    }
  }

  @Watch("internalValue")
  onInternalValueChange(val: boolean) {
    this.$emit("input", val);
  }

  async fetchPPDData() {
    this.loading = true;
    await this.$store.dispatch("schedule/getSchedulePpdDetail", {
      date: this.date,
    });
    this.loading = false;
  }

  get departments(): DepartmentPPD[] {
    const raw = this.$store.getters["schedule/schedulePpdDetail"] ?? [];

    let rawDepartments: DepartmentSchedulePPD[];

    if (checkSelfRole("owner")) {
      rawDepartments = (raw as AllSchedulePPD)?.departments;
    } else {
      rawDepartments = (raw as DepartmentSchedulePPD[]) ?? [];
    }

    const departments = this.transformPpdData(rawDepartments);
    return departments ?? [];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transformPpdData(raw: DepartmentSchedulePPD[]): DepartmentPPD[] {
    /* eslint-disable @typescript-eslint/camelcase */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rawDepartments = raw?.map((dept: any) => ({
      department_id: dept.department_id,
      department_name: dept.department_name,
      target_ppd: dept.target_ppd ?? null,
      actual_work_hour: dept.actual_work_hour ?? null,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      titles: (dept.titles ?? []).map((title: any) => ({
        title_id: title.title_id,
        title_name: title.title_name,
        target_ppd: title.target_ppd ?? null,
        actual_work_hour: title.actual_work_hour ?? null,
      })),
    }));

    return rawDepartments;
  }

  async save() {
    this.saving = true;
    try {
      /* eslint-disable @typescript-eslint/camelcase */
      // eslint-disable-next-line
      const isEmpty = (v: any) => v == null || v === 0;
      const records: SchedulePPD[] = [];
      for (const dept of this.departments) {
        const deptUsed =
          !isEmpty(dept.target_ppd) || !isEmpty(dept.actual_work_hour);

        if (deptUsed) {
          records.push({
            department_id: dept.department_id,
            department_title_id: null,
            target_ppd: dept.target_ppd ?? null,
            actual_work_hour: dept.actual_work_hour ?? null,
            ppd: 0,
            date: this.date,
          });
        } else {
          for (const title of dept.titles ?? []) {
            if (isEmpty(title.target_ppd) && isEmpty(title.actual_work_hour)) {
              continue;
            }
            records.push({
              department_id: dept.department_id,
              department_title_id: title.title_id,
              target_ppd: title.target_ppd ?? null,
              actual_work_hour: title.actual_work_hour ?? null,
              ppd: 0,
              date: this.date,
            });
          }
        }
      }
      /* eslint-enable @typescript-eslint/camelcase */
      await this.$store.dispatch("schedule/saveSchedulePpd", records);
      this.$store.commit(
        "alert/SET_SHOW_SUCCESS",
        "PPD data saved successfully!",
        { root: true },
      );
      this.$emit("saved");
      this.close();
    } catch {
      // errors handled in store
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.internalValue = false;
    this.activeValue = -1;
  }
}
